import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import * as React from 'react';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ROOT],
  Screens.RootPage
>;

export const HomeWithoutSidebarIos26: React.FC<Props> = () => {
  return null;
};
